/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowALeftIcon32Regular = forwardRef('ArrowALeftIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M13.957 25.793a1 1 0 1 1-1.414 1.414l-8.379-8.379a4 4 0 0 1 0-5.656l8.379-8.38a1 1 0 1 1 1.414 1.415l-8.379 8.379A2.003 2.003 0 0 0 5.26 15H28a1 1 0 1 1 0 2H5.26c.086.148.192.288.318.414l8.38 8.379Z" })));
});
